import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

firebase.initializeApp({
    apiKey: "AIzaSyDpqlA9Rm67VW6jnC-ZzxYZZNyW3CekVMQ",
    authDomain: "photon-6d209.firebaseapp.com",
    databaseURL: "https://photon-6d209.firebaseio.com",
    projectId: "photon-6d209",
    storageBucket: "photon-6d209.appspot.com",
    messagingSenderId: "729201786634"
})

export default firebase

    


// WEBPACK FOOTER //
// ./src/firebase.js